import React from 'react';
import classNames from 'classnames/bind';

import styles from './HoverCard.module.scss';

let cx = classNames.bind(styles);

const HoverCard = ({ background_url, title, subtitle, text, cta }) => {
	return (
		<div
			className={cx({ background: true, '': true })}
			style={{ backgroundImage: `url(${background_url})` }}
		>
			<div className={cx({ display_over: true })}>
				<div className={cx({ big_title: true })}>{title}</div>
				<div
					className={cx({
						hover: true,
						'flex flex-col justify-center items-center': true,
					})}
				>
					{subtitle && (
						<div className={cx({ sub_title: true })}>{subtitle}</div>
					)}
					<div
						className={cx({ paragraph: true, 'p-4 text-base lg:text-xl text-center font-Avenir-Black': true })}
					>
						{text}
					</div>
					{cta && <div className={cx({ cta: true })}> {cta} </div>}
				</div>
			</div>
		</div>
	);
};

export default HoverCard;
